module.exports = __webpack_public_path__ + "a06ac0b43e450ead91c2f15c973f0115.jpg";